import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { CanonicalService } from '../../../shared/seo/canonical.service';

@Component({
  selector: 'app-portfolio',
  imports: [RouterModule, CommonModule],
  templateUrl: './portfolio.component.html',
  styleUrl: './portfolio.component.scss',
  encapsulation: ViewEncapsulation.None, // ✅ Make sure this line is here
})
export class PortfolioComponent implements OnInit {
  activeIndex: number | null = null;

  constructor(
    private title: Title,
    private meta: Meta,
    private canonicalService: CanonicalService
  ) {}
  Portfolio() {
    const plansSection = document.getElementById('open-roles');
    if (plansSection) {
      plansSection.scrollIntoView({ behavior: 'smooth' });
    }
  }
  ngOnInit(): void {
    // Set page title
    this.title.setTitle('MALtech Portfolio | Software & Client Success');
    // Set meta description
    this.meta.updateTag({
      name: 'description',
      content:
        'Explore MALtech Solutions portfolio showcasing successful projects across various industries. Discover our expertise in delivering innovative IT solutions that drive business growth and transformation.',
    });
    // Set meta keywords
    this.meta.updateTag({
      name: 'keywords',
      content: 'portfolio, projects, case studies, it solutions',
    });
    this.canonicalService.setCanonicalURL('portfolio/');
  }

  serviceCards = [
    {
      title: 'Software Development',
      icon: 'bi bi-code-slash',
      desc: 'We design and build powerful web, mobile, and enterprise applications that are user-friendly, scalable, and tailored to your business goals.',
    },
    {
      title: 'Software Consulting',
      icon: 'bi bi-people',
      desc: 'Strategic guidance, architecture planning, and optimization to help organizations choose the right technologies and maximize ROI.',
    },
    {
      title: 'DevOps & Cloud',
      icon: 'bi bi-cloud',
      desc: 'From CI/CD pipelines to cloud deployment, we deliver scalable infrastructure on AWS, Azure, and GCP.',
    },
    {
      title: 'Digital Marketing',
      icon: 'bi bi-megaphone',
      desc: 'SEO, content marketing, social media, and analytics strategies to maximize reach and conversions.',
    },
  ];

  faqItems = [
    {
      question: 'Why MALtech Solutions?',
      answer:
        'At MALtech, we enterprise to give an alarming platform for professionals who will be our catalysts to dominate and reclassify the limits of technology to make our clients fruitful. Our engagement team focuses on the recruitment of talented professionals in the industry. Look no further if you are on a hunt for excellence in IT and searching for a challenging opportunity.',
      open: false,
    },
    {
      question: 'What do we do?',
      answer:
        'We assist customers to do business better by leveraging our profound technical expertise and extensive portfolio of services. We believe in a strong culture of innovation and a tireless spotlight on customer relationships.',
      open: false,
    },
    {
      question: 'What are Career Opportunities?',
      answer:
        'MALtech operates nationally and globally, supported by a huge talent pool at all levels. We encourage skilled talent at every stage of their career, right from freshers, entry-level through to extremely experienced industry leaders.',
      open: false,
    },
  ];

  toggleFaq(index: number) {
    this.faqItems[index].open = !this.faqItems[index].open;
  }
}
